



















































import Vue from "vue";
import Icon from "@/components/Icon.vue";

import Icons from "@/icons";

export default Vue.extend({
  name: "App",
  components: { Icon },
  data: () => ({
    icons: [{ icon: "", meta: {} }],
    mdiIcons: new Icons(),
    search: ""
  }),
  methods: {
    // load more icons
    loadMore() {
      if (this.search === "" && this.icons.length !== 1) {
        const icons = this.mdiIcons.getIcons(this.icons.length);
        icons.forEach(item => this.icons.push(item));
      }
    },

    // search icons
    searchIcons() {
      this.icons = this.mdiIcons.search(this.search.toLowerCase());
    },

    // clear search
    clearSearch() {
      if (this.search !== "") {
        this.search = "";
        this.icons = this.mdiIcons.getIcons();
      }
    }
  },
  async created() {
    await this.mdiIcons.init();
    this.icons = this.mdiIcons.getIcons();
  }
});
